import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import OrderForm from './OrderForm';

export default function EmbedForm() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        // Send new height to parent window
        window.parent.postMessage({
          type: 'FORM_RESIZE',
          height: entry.contentRect.height
        }, '*');
      }
    });

    // Start observing the form container
    const formContainer = document.querySelector('.embed-container');
    if (formContainer) {
      resizeObserver.observe(formContainer);
    }

    setLoading(false);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="embed-container">
      <OrderForm isEmbedded={true} />
    </div>
  );
}